import React, { useEffect, useState } from 'react'
import MenuIcon from '@mui/icons-material/Menu';
import axios from 'axios';
import CustomSpinner from '../../components/CustomSpinner';
import { ConfigProvider, Pagination } from "antd";
import InputBase from '@mui/material/InputBase'
import IconButton from '@mui/material/IconButton'
import SearchIcon from '@mui/icons-material/Search'

import dayjs from "dayjs"

function MailConnectionStatus({
    serverURL,
    user,
    setShowSideOverlay,
    socket,
    onlineUsers,
    logToUse,
    setLogToUse,
    setPageViews,
    setNewPath,
}) {



    const [globleSearchValues, setGlobleSearchValues] = useState("")
    const [currentPageNumber, setCurrentPageNumber] = useState(1)
    const [loadingEntries, setLoadingEntries] = useState(true);
    const [entriesLimit, setEntriesLimit] = useState(100)
    const [skipEntries, setSkipEntries] = useState(0)
    const [totalEntriesCount, setTotalEntriesCount] = useState(0)


    const [allStudentsMail, setAllStudentsMail] = useState([])
    const [spinnerLoading, setSpinnerLoading] = useState(false)
    const getAllStudentMails = async () => {
        setSpinnerLoading(true)
        const getNow = await axios.post(serverURL + "/mailConnections/getDataWithFilter", {
            searchValue: globleSearchValues,
            limit: entriesLimit,
            skip: skipEntries,
        })

        if (getNow.status === 200) {
            setTotalEntriesCount(getNow.data.total)
            setAllStudentsMail(getNow.data.records)
            setSpinnerLoading(false)
        } else {
            console.log(getNow.data)
            setSpinnerLoading(false)
        }
    }

    const showToolPit = (target) => {

        const notification = document.createElement("div")
        const textNode = document.createTextNode("Copied!")
        notification.appendChild(textNode)
        notification.style = `position:fixed;top:${target.screenY}px;left:${target.screenY}px;text-transform:capitalize;background:#ffce00;color:black;font-weght:bold;font-size:12px;letter-spacing:2px;filter:drop-shadow(0 0 4px rgba(0,0,0,0.5));border-radius:10px;padding:10px;`
        target.appendChild(notification)

        setTimeout(() => {
            target.removeChild(notification)
        }, 1000)
    }

    useEffect(() => {
        getAllStudentMails()

        console.log(skipEntries)
    }, [entriesLimit, skipEntries, globleSearchValues])

    useEffect(() => {
        getAllStudentMails()
    }, [])


    return (
        <>
            <div className="transback h-100 overflow-auto p-3 d-flex flex-column">
                <button
                    className="btn text-secondary rounded-pill px-3 py-1 d-flex d-lg-none align-items-center gap-2"
                    onClick={() => setShowSideOverlay(true)}
                >
                    <MenuIcon />
                </button>
                <div className="headerUserDetails py-1 d-flex justify-content-between">
                    <span>Mail Connection Status</span>
                    <div
                        className="d-flex gap-2 align-items-center"
                        title={`Name: ${user.name} | Email: ${user.email}`}
                    >
                        <i className="fa fa-user"></i>
                        <span>{user.name}</span>
                    </div>
                </div>


                <div className='d-flex gap-2 justify-content-between align-items-streach px-3 py-3 shadow-sm w-100'>
                    <span></span>
                    <div className='d-flex align-items-center gap-3'>
                        <div className='d-flex shadow-sm rounded-pill border px-1'>
                            <InputBase
                                sx={{ ml: 1, flex: 1 }}
                                placeholder="Global Search"
                                inputProps={{ 'aria-label': 'Global Search' }}
                                onChange={(e) => { console.log(e.target.value); setGlobleSearchValues(e.target.value) }}
                            />
                            <IconButton type="button" sx={{ p: '5px' }} aria-label="search">
                                <SearchIcon />
                            </IconButton>
                        </div>
                    </div>
                </div>

                <div className="w-100 h-100 overflow-auto ">
                    {
                        spinnerLoading ?
                            <div className='w-100 h-100 d-flex align-items-center justify-content-center'>
                                <CustomSpinner size={1} />
                            </div>
                            :
                            <table className='table table-yesgermany table-hover table-bordered table-striped shadow-sm m-0'>
                                <thead className='sticky-top'>
                                    <tr valign="middle">
                                        <th valign="middle" className='text-nowrap text-center'>#{allStudentsMail.length}</th>
                                        <th valign="middle" className='text-nowrap text-center'>STUDENT ID</th>
                                        <th valign="middle" className='text-nowrap text-center'>STUDENT STATUS</th>
                                        <th valign="middle" className='text-nowrap text-center'>EMAIL</th>
                                        <th valign="middle" className='text-nowrap text-center'>PASSWORD</th>
                                        <th valign="middle" className='text-nowrap text-center'>Connection Status</th>
                                        <th valign="middle" className='text-nowrap text-center'>Last Synced (Since {dayjs().subtract(2, "days").format("D MMM YYYY")})</th>
                                        <th valign="middle" className='text-nowrap text-center'>Total Emails</th>
                                        <th valign="middle" className='text-nowrap text-center'>Today Emails</th>
                                        <th valign="middle" className='text-nowrap text-center'>INBOX</th>
                                        <th valign="middle" className='text-nowrap text-center'>Junk</th>
                                        <th valign="middle" className='text-nowrap text-center'>Spam</th>
                                        <th valign="middle" className='text-nowrap text-center'>Draft</th>
                                        <th valign="middle" className='text-nowrap text-center'>Sent</th>
                                        <th valign="middle" className='text-nowrap text-center'>Trash</th>
                                        <th valign="middle" className='text-nowrap text-center'>Archive</th>
                                    </tr>
                                </thead>
                                {
                                    allStudentsMail ?
                                        allStudentsMail.length > 0 ?
                                            allStudentsMail.map((student, key) => {
                                                return (
                                                    <React.Fragment key={key}>

                                                        <tbody>
                                                            <tr>
                                                                <td width="1%" rowSpan={2} valign="middle" className='text-nowrap text-center'>{skipEntries + (key + 1)}</td>
                                                                <td width="1%" rowSpan={2} valign="middle" className='text-nowrap text-center'>{student.stdid}</td>
                                                                <td width="1%" rowSpan={2} valign="middle" className='text-nowrap text-center'>{student.ststatus}</td>
                                                                <td width="1%" valign="middle" className='text-nowrap text-center'>{student.primaryEmail.email ? student.primaryEmail.email : "---"}</td>
                                                                <td width="1%" valign="middle" className='text-nowrap text-center' style={{ fontSize: "1.3rem", color: "#ffce00", cursor: "pointer" }} onClick={(e) => { showToolPit(e.target); navigator.clipboard.writeText(student.primaryEmail.password); }}><i className='fa fa-copy'></i></td>
                                                                <td width="1%" valign="middle" className='text-nowrap text-start'>{student.primaryEmail.connectionStatus === "Active" ? "🟢" : "🔴"} {student.primaryEmail.connectionStatus}</td>
                                                                <td width="1%" valign="middle" className='text-nowrap text-center'>{student.primaryEmail.lastFetched}</td>
                                                                <td width="1%" valign="middle" className='text-nowrap text-center' style={student.primaryEmail.totalEmails > 0 ? { "background": "yellow", "color": "black" } : {}}>{student.primaryEmail.totalEmails ? student.primaryEmail.totalEmails : 0}</td>
                                                                <td width="1%" valign="middle" className='text-nowrap text-center' style={student.primaryEmail.todayEmails > 0 ? { "background": "yellow", "color": "black" } : {}}>{student.primaryEmail.todayEmails ? student.primaryEmail.todayEmails : 0}</td>
                                                                <td width="1%" valign="middle" className='text-nowrap text-center' style={student.primaryEmail.INBOX > 0 ? { "background": "yellow", "color": "black" } : {}}>{student.primaryEmail.INBOX ? student.primaryEmail.INBOX : 0}</td>
                                                                <td width="1%" valign="middle" className='text-nowrap text-center' style={student.primaryEmail.Junk > 0 ? { "background": "yellow", "color": "black" } : {}}>{student.primaryEmail.Junk ? student.primaryEmail.Junk : 0}</td>
                                                                <td width="1%" valign="middle" className='text-nowrap text-center' style={student.primaryEmail.Spam > 0 ? { "background": "yellow", "color": "black" } : {}}>{student.primaryEmail.Spam ? student.primaryEmail.Spam : 0}</td>
                                                                <td width="1%" valign="middle" className='text-nowrap text-center' style={student.primaryEmail.Draft > 0 ? { "background": "yellow", "color": "black" } : {}}>{student.primaryEmail.Draft ? student.primaryEmail.Draft : 0}</td>
                                                                <td width="1%" valign="middle" className='text-nowrap text-center' style={student.primaryEmail.Sent > 0 ? { "background": "yellow", "color": "black" } : {}}>{student.primaryEmail.Sent ? student.primaryEmail.Sent : 0}</td>
                                                                <td width="1%" valign="middle" className='text-nowrap text-center' style={student.primaryEmail.Trash > 0 ? { "background": "yellow", "color": "black" } : {}}>{student.primaryEmail.Trash ? student.primaryEmail.Trash : 0}</td>
                                                                <td width="1%" valign="middle" className='text-nowrap text-center' style={student.primaryEmail.Archive > 0 ? { "background": "yellow", "color": "black" } : {}}>{student.primaryEmail.Archive ? student.primaryEmail.Archive : 0}</td>
                                                            </tr>
                                                            <tr>
                                                                <td width="1%" valign="middle" className='text-nowrap text-center'>{student.secondaryEmail.email ? student.secondaryEmail.email : "---"}</td>
                                                                <td width="1%" valign="middle" className='text-nowrap text-center' style={{ fontSize: "1.3rem", color: "#ffce00", cursor: "pointer" }} onClick={(e) => { showToolPit(e.target); navigator.clipboard.writeText(student.secondaryEmail.password); }}><i className='fa fa-copy'></i> </td>
                                                                <td width="1%" valign="middle" className='text-nowrap text-start'>{student.secondaryEmail.connectionStatus === "Active" ? "🟢" : "🔴"} {student.secondaryEmail.connectionStatus}</td>
                                                                <td width="1%" valign="middle" className='text-nowrap text-center'>{student.secondaryEmail.lastFetched}</td>
                                                                <td width="1%" valign="middle" className='text-nowrap text-center' style={student.secondaryEmail.totalEmails > 0 ? { "background": "yellow", "color": "black" } : {}}>{student.secondaryEmail.totalEmails ? student.secondaryEmail.totalEmails : 0}</td>
                                                                <td width="1%" valign="middle" className='text-nowrap text-center' style={student.secondaryEmail.todayEmails > 0 ? { "background": "yellow", "color": "black" } : {}}>{student.secondaryEmail.todayEmails ? student.secondaryEmail.todayEmails : 0}</td>
                                                                <td width="1%" valign="middle" className='text-nowrap text-center' style={student.secondaryEmail.INBOX > 0 ? { "background": "yellow", "color": "black" } : {}}>{student.secondaryEmail.INBOX ? student.secondaryEmail.INBOX : 0}</td>
                                                                <td width="1%" valign="middle" className='text-nowrap text-center' style={student.secondaryEmail.Junk > 0 ? { "background": "yellow", "color": "black" } : {}}>{student.secondaryEmail.Junk ? student.secondaryEmail.Junk : 0}</td>
                                                                <td width="1%" valign="middle" className='text-nowrap text-center' style={student.secondaryEmail.Spam > 0 ? { "background": "yellow", "color": "black" } : {}}>{student.secondaryEmail.Spam ? student.secondaryEmail.Spam : 0}</td>
                                                                <td width="1%" valign="middle" className='text-nowrap text-center' style={student.secondaryEmail.Draft > 0 ? { "background": "yellow", "color": "black" } : {}}>{student.secondaryEmail.Draft ? student.secondaryEmail.Draft : 0}</td>
                                                                <td width="1%" valign="middle" className='text-nowrap text-center' style={student.secondaryEmail.Sent > 0 ? { "background": "yellow", "color": "black" } : {}}>{student.secondaryEmail.Sent ? student.secondaryEmail.Sent : 0}</td>
                                                                <td width="1%" valign="middle" className='text-nowrap text-center' style={student.secondaryEmail.Trash > 0 ? { "background": "yellow", "color": "black" } : {}}>{student.secondaryEmail.Trash ? student.secondaryEmail.Trash : 0}</td>
                                                                <td width="1%" valign="middle" className='text-nowrap text-center' style={student.secondaryEmail.Archive > 0 ? { "background": "yellow", "color": "black" } : {}}>{student.secondaryEmail.Archive ? student.secondaryEmail.Archive : 0}</td>
                                                            </tr>
                                                        </tbody>
                                                    </React.Fragment>
                                                )
                                            })
                                            :
                                            <tr>
                                                <td colSpan={16} valign="middle">No Data</td>
                                            </tr>
                                        :
                                        <tr>
                                            <td colSpan={16} valign="middle">No Data</td>
                                        </tr>

                                }
                            </table>
                    }

                </div>
                <div className='w-100 mt-2 customBackgroundFilter rounded'>
                    <ConfigProvider
                        theme={{
                            components: {
                                Pagination: {
                                    itemActiveBg: "#faf089",
                                    itemActiveBgDisabled: "yellow",
                                    // itemActiveColorDisabled: "",
                                    // itemBg: "",
                                    // itemInputBg: "",
                                    // itemLinkBg: "",

                                },
                            },
                            token: {
                                // colorBgContainer: "",
                                // colorBgContainerDisabled: "",
                                // colorBgTextActive: "",
                                colorBgTextHover: "rgba(255, 246, 164, 0.73)",
                                // colorBorder: "red",
                                // colorPrimary: "",
                                // colorPrimaryBorder: "#faf089",
                                // colorPrimaryHover: "",
                                // colorText: "",
                                // colorTextDisabled: "",
                                // colorTextPlaceholder: "",
                                // borderRadius: "",
                                // borderRadiusLG: "",
                                // borderRadiusSM: "",
                                // controlHeight: "",
                                // controlOutline: "",
                                // controlOutlineWidth: "",
                                // fontFamily: "",
                                // fontSize: "",
                                // lineHeight: "",
                                margin: 0,
                                // motionDurationMid: "",
                                // paddingXXS: ""
                            }
                        }}
                    >
                        <Pagination defaultCurrent={2} current={currentPageNumber} defaultPageSize={entriesLimit} showSizeChanger={true} showQuickJumper={true} simple={false} disabled={false} total={totalEntriesCount} onChange={(e) => { setCurrentPageNumber(e); setSkipEntries((e - 1) * entriesLimit) }} onShowSizeChange={(page, pageSize) => { setEntriesLimit(pageSize) }} />
                    </ConfigProvider>
                </div>
            </div>
        </>
    )
}

export default MailConnectionStatus